import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bevvi-partner-page',
  templateUrl: './partner-page.component.html',
  styleUrls: ['./partner-page.component.scss']
})
export class PartnerPageComponent implements OnInit {
  public imageUrl = "assets/images/banner-img/partner-banner.png";

  headingTitle = "Become a Partner";
  paragraphInfo = "Join the Bevvi network to bring your offerings to a wider audience. Whether you’re a local retailer or a brand partner, team up with us to tap into a wide network of businesses and buyers. Get in touch to start our partnership journey!"

  constructor() { }

  ngOnInit() {
  }

}
